import { render, staticRenderFns } from "./app-alert.vue?vue&type=template&id=34578564&scoped=true&"
import script from "./app-alert.vue?vue&type=script&lang=js&"
export * from "./app-alert.vue?vue&type=script&lang=js&"
import style0 from "./app-alert.vue?vue&type=style&index=0&id=34578564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34578564",
  null
  
)

export default component.exports